export default "__VITE_PUBLIC_ASSET__73bf4ecb__"